import React from 'react'
import PropTypes from 'prop-types'
import { Navigate } from 'react-router-dom'

const RequireAuthComp = ({ children, user, router }) => {
  if (user) {
    return children
  } else {
    return (
      <Navigate to="/auth" state={{ from: router.location.pathname }} replace />
    )
  }
}

RequireAuthComp.propTypes = {
  children: PropTypes.node,
  user: PropTypes.object,
}

export default RequireAuthComp
